<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<!--机柜分组列表-->
			<div class="text-right">
				<el-button type="primary" v-if="!ifEdit" @click="showAddGroup()"><i class="fa fa-plus"></i> 添加分组</el-button>
			</div>
			<div :class="{active:ifEdit}">
				<div class="secNav devList" v-if="activeGroupIndex==-1 && ifEdit">
					<h3 class="relative-box">
						<input v-model="newGroupName" placeholder="新建分组名称" v-if="ifEdit && activeGroupIndex==-1" />
						
						<button class="btn btn-group2" v-if="ifEdit && activeGroupIndex==-1" @click="cancelEdit()">取消</button>
						<button class="btn btn-primary btn-group" v-if="ifEdit && activeGroupIndex==-1" @click="addGroup()">添加</button>
					</h3>
					<ul>
						<li @click="clickDev(item,index,groupIndex)" v-for="(item,index) in addGroupDev.devices" :key="index">
							<span><i class="fa fa-tachometer"></i></span>
				            <a v-text="item.device_name" href="javascript:void(0);"></a>
				          </li>
					</ul>
				</div>
				<div class="secNav devList" :class="{activeGroup:activeGroupIndex==groupIndex}" v-for="(group,groupIndex) in deviceList" :key="groupIndex">
					<h3 class="relative-box">
						<strong v-if="!ifEdit || activeGroupIndex!=groupIndex || group.group_name=='动环'">{{group.group_name}}</strong>
						<input v-model="group.group_name" v-if="ifEdit && activeGroupIndex==groupIndex && group.group_name!='动环'" />
						
						<button class="btn btn-group" v-if="!ifEdit && group.packet_id!=0" @click="editNow(group,groupIndex)">编辑</button>
						<button class="btn btn-primary btn-group" v-if="ifEdit && activeGroupIndex==groupIndex" @click="saveGroup()">保存</button>
						<button class="btn btn-group3" v-if="ifEdit && activeGroupIndex==groupIndex" @click="cancelEdit()">取消</button>
						<button class="btn btn-group2" v-if="ifEdit && activeGroupIndex==groupIndex" @click="clickDelete()">删除</button>
					</h3>
					
					<ul>
						<li @click="clickDev(item,index,groupIndex)" v-for="(item,index) in group.devices" :key="index">
							<span><i class="fa fa-tachometer"></i></span>
				            <a v-text="item.device_name" href="javascript:void(0);"></a>
				          </li>
					</ul>
				</div>
			</div>
			
		</div>
		<!--删除确认框-->
		<el-dialog title="提示框" :visible.sync="deleteDialogFlag" width="500px" >
		    <div class="userInfo">
				<h4>删除后不可恢复，确认删除吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="deleteDialogFlag = false">取消</el-button>
			    <el-button type="primary" @click="confirmDelete()">确定</el-button>
			  </div>
		</el-dialog>
		
		<!--设备名称编辑框-->
		<el-dialog title="设备更名" :visible.sync="devDialogFlag" width="500px" >
		    <el-form>
	        	<el-form-item label="设备名称" label-width="80px">
			    	<el-input v-model="changeNameDev.device_name" auto-complete="off"></el-input>
			    </el-form-item>
	            
	        </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancelChangeName()">取消</el-button>
			    <el-button type="primary" @click="confirmChangeDevName()">保存</el-button>
			  </div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		this.getAllList();
		  		
		  	})
		},
		data() {
		  	return {
		  		deviceList:[],
		  		ifEdit:false,
		  		activeGroupIndex:0,
		  		deleteDialogFlag:false,
//		  		未分组设备组
		  		undefinedGroup:{},
		  		device_ids:[],
		  		newGroupName:"",
		  		addGroupDev:{
		  			devices:[]
		  		},
		  		beforName:"",
		  		devDialogFlag:false,
		  		changeNameDev:{
		  			device_name:""
		  		}
		  	}
		},
		methods:{
//			点击添加分组
			showAddGroup(){
				this.ifEdit = true;
				this.activeGroupIndex = -1;
				this.newGroupName = "";
				this.addGroupDev = {
		  			devices:[]
		  		}
			},
//			点击删除
			clickDelete(){
				this.deleteDialogFlag = true;
			},
//			取消编辑
			cancelEdit(){
				this.ifEdit = false;
				this.getAllList()
			},
//			确认修改设备名称
			confirmChangeDevName(){
				let devNameParams={
					uid:this.getCookie('uid'),
					device_id: this.changeNameDev.id,
					device_name: this.changeNameDev.device_name,
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign(devNameParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/EquipmentSave/EquipmentSave",this.$qs.stringify(devNameParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.devDialogFlag = false;
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
			},
//			确定删除分组
			confirmDelete(){
				let confirmDeleteParams={
					uid:this.getCookie('uid'),
					packet_id:this.deviceList[this.activeGroupIndex].packet_id || "",
					group_name:this.deviceList[this.activeGroupIndex].group_name || "",
		  			token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign(confirmDeleteParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/GroupDelete/GroupDelete",this.$qs.stringify(confirmDeleteParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.deleteDialogFlag = false;
		        	this.ifEdit = false;
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg);
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg);
		        	}
		  		});
		  		this.getAllList();
			},
			addGroup(){
				this.device_ids = [];
				
				var savedGroupDev = this.addGroupDev.devices;
				
				for(var i=0;i<savedGroupDev.length;i++){
					
					this.device_ids.push(parseInt(savedGroupDev[i].id));
				}
				if(this.newGroupName==""){
					this.$message.warning("设备分组名称不能为空");
				}
//				else if(this.device_ids.length==0){
//					this.$message.warning("设备分组设备不能为空");
//				}
				else{
					this.ifEdit = false;
					this.device_ids = JSON.stringify(this.device_ids).replace(/\[|]/g,'');

					let valiCodeParams={
						uid:this.getCookie('uid'),
						group_name:this.newGroupName,
						device_ids:this.device_ids,
						token:this.getCookie('token'),
						time:Date.parse( new Date()),
						terminalId:4
			  		};
			  		this.sign(valiCodeParams);
			  		this.$ajax.post(this.$store.state.domain+"/Home/GroupAdd/GroupAdd",this.$qs.stringify(valiCodeParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		this.$message.success(res.data.msg);
			        		
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
			        	}else{
			        		//console.log(res.data.msg);
			        		this.$message.error(res.data.msg);
			        	}
			        	this.getAllList();
			  		});
				}
				
			},
//			点击保存
			saveGroup(){
				this.device_ids = [];
				this.ifEdit = false;
				var savedGroupDev = this.deviceList[this.activeGroupIndex].devices;
				
				for(var i=0;i<savedGroupDev.length;i++){
					
					this.device_ids.push(parseInt(savedGroupDev[i].id));
				}
				this.device_ids = JSON.stringify(this.device_ids).replace(/\[|]/g,'');
//				if(this.device_ids.length==0){
//					this.$message.warning("分组设备不能为空");
//				}
				let valiCodeParams={
					uid:this.getCookie('uid'),
					packet_id:this.deviceList[this.activeGroupIndex].packet_id || "",
					group_name:this.deviceList[this.activeGroupIndex].group_name || "",
					device_ids:this.device_ids || "",
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/GroupEdit/GroupEdit",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
		        		this.$message.success(res.data.msg,1000);
		        		
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        		this.$message.error(res.data.msg);
		        	}
		        	this.getAllList();
		  		});
			},
//			点击编辑
			editNow(group,index){
				this.activeGroupIndex = index;
				this.ifEdit = true;
			},
//			点击设备
			clickDev(item,index,groupIndex){
//				如果在编辑状态
				if(this.ifEdit){
//					设备增多组
					var editGroup;
//					点击设备所在分组
					var editGroup2 = this.deviceList[groupIndex];
//					新增设备分组
					
//					if(editGroup2.devices.length<=1){
//						this.$message.error("分组设备不能为空")
//					}else{
//						editGroup2.devices.splice(index,1);
//							if(this.activeGroupIndex==-1){
//							editGroup = this.addGroupDev;
//						}
//						else if(groupIndex!=this.activeGroupIndex){
//							editGroup = this.deviceList[this.activeGroupIndex];
//						}
//						else{
//							if(item.packet_id==this.deviceList[groupIndex].packet_id){
//								editGroup = this.undefinedGroup;
//							}else{
//								
//								for(var i=0;i<this.deviceList.length;i++){
//									if(this.deviceList[i].packet_id==item.packet_id){
//										editGroup = this.deviceList[i];
//									}
//								}
//							}
//						}
//						editGroup.devices.push(item);
//					}

					editGroup2.devices.splice(index,1);
						if(this.activeGroupIndex==-1){
						editGroup = this.addGroupDev;
					}
					else if(groupIndex!=this.activeGroupIndex){
						editGroup = this.deviceList[this.activeGroupIndex];
					}
					else{
						if(item.packet_id==this.deviceList[groupIndex].packet_id){
							editGroup = this.undefinedGroup;
						}else{
							
							for(var i=0;i<this.deviceList.length;i++){
								if(this.deviceList[i].packet_id==item.packet_id){
									editGroup = this.deviceList[i];
								}
							}
						}
					}
					editGroup.devices.push(item);
					
				}else{
					this.devDialogFlag = true;
					this.beforName= item.device_name;
					this.changeNameDev = item;
				}
				
			},
			//取消编辑名称
			cancelChangeName(){
				this.devDialogFlag = false;
				this.changeNameDev.device_name = this.beforName;
			},
			getAllList(){
				let setNewPassParams={
		  			uid:this.getCookie('uid'),
		  			packet_id:-1,
		  			timestamp:Date.parse( new Date()),
		  		    terminalId:1
		  		};
		  		this.sign(setNewPassParams);
		  		this.$ajax.post(this.$store.state.domain+"/Home/AllList/AllList",this.$qs.stringify(setNewPassParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.status==1){
//		        		获取数据后处理成需要数据
						var Data = res.data.data;
						// 如果列表没有未分组，添加未分组
						// 未分组ID固定为0
						let ifUnlist = true;
						for(var i = 0; i < Data.length; i++){
							if(Data[i].group_name=="未分组"){
								ifUnlist = false
							}
						}
						if(ifUnlist){
							Data.splice(0,0,{
								devices: "",
								group_name: "未分组",
								packet_id: "0"
							})
						}		        		
	                    for (var i = 0; i < Data.length; i++) {
							if(Data[i].devices!=""){
								var devicesz = Data[i].devices.split(",");
								Data[i].devices = devicesz;
								for (var j = 0; j < Data[i].devices.length; j++) {
									var deviceszs = Data[i].devices[j].split("|");
									var equipment;
									for (var z = 0; z < deviceszs.length; z++) {
										var equipment = {
											"id": deviceszs[0],
											"device_name": deviceszs[1],
											"packet_id": Data[i].packet_id,
											// "mac_address": "88878788",
											"equipment_staus": deviceszs[2],
											"equipment_open": deviceszs[3],
											"equipment_type": deviceszs[4]
										}
									}
									var deviceszsz = equipment;
									Data[i].devices[j] = deviceszsz;
								}
							}else{
								Data[i].devices = []
							}
	                        
						}						
	                    this.deviceList = Data;	                    
//	                    循环数组,给未分组赋值						
	                    for(var i=0;i<this.deviceList.length;i++){	                    	
	                    	if(this.deviceList[i].group_name=="未分组"){	                    		
								this.undefinedGroup = this.deviceList[i];	
								console.log(this.undefinedGroup)							
	                    	}
						}					
                    
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);  
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
				
			},
			closeDialog(){
				this.$router.push('/login');
			}
			
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/deviceGroup.vue